import { render } from "./Praxis.vue?vue&type=template&id=46b7c3c9"
import script from "./Praxis.vue?vue&type=script&lang=js"
export * from "./Praxis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__